import React from 'react';
import PropTypes from 'prop-types';
import WireBlack from '@learningblocks/exp-constants/lib/Images/ps_modal_wire_black.svg';
import WireRed from '@learningblocks/exp-constants/lib/Images/ps_modal_wire_red.svg';
import {Image} from '@learningblocks/shared-components/lib/Image';

import './style.scss';

const WIRE = {
  BLACK: 'black',
  RED: 'red',
};

const ANODE_KEY = 'anode';
const CATHODE_KEY = 'cathode';

export function Cables(props) {
  const getWireSrc = (type) => {
    if (props[type] === WIRE.BLACK) return WireBlack;
    else if (props[type] === WIRE.RED) return WireRed;
    else return null;
  };

  return (
    <div className={`ps_cables  ${props.className}`}>
      <Image 
        className='ps_cables_anode' src={getWireSrc(ANODE_KEY)}
        alt='Anode power input jack'
        style={{
          display: getWireSrc(ANODE_KEY) ? "block" : "none",
        }}
      />
      <Image
        className='ps_cables_cathode' src={getWireSrc(CATHODE_KEY)}
        alt='Cathode power input jack'
        style={{
          display: getWireSrc(CATHODE_KEY) ? "block" : "none",
        }}
      />
    </div>
  );
}

Cables.propTypes = {
  /**
   * classname
   */
  className: PropTypes.string,
  /**
   * specifies wire type in anode
   */
  anode: PropTypes.string,
  /**
   * specifies wire type in cathode
   */
  cathode: PropTypes.string,
};
